import React from 'react';
import { pure, compose } from 'react-recompose';
// hocs
import { withAsyncInitialDataOnDidMount } from '../../../hocs';
// feature payroll
import PayrollInvoices from './payroll-invoices';
//////////////////////////////////////////////////

const enhance = compose(
  withAsyncInitialDataOnDidMount,
  pure,
);

const AsyncPayrollInvoices = (props) => {
  const { data, loading } = props.asyncInitialData;

  const parentProps = {
    detailsWidth: '100%',
    detailsLoading: loading,
  };

  return (
    <PayrollInvoices
      data={data}
      actionsDisabled={true}
      parentProps={parentProps}
    />
  );
};

export default enhance(AsyncPayrollInvoices);

